import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer>
        <small>&copy; 2018 <Link to="mailto:jaymes@example.com">Homeless Resources</Link></small>
    
        <ul>
          <li><Link to="/">Home</Link> | </li>
          <li><Link to="/statistics" title="">Statistics</Link> | </li>
          <li><Link to="/help" title="How to help Homeless Needs">Help</Link> | </li>
          <li><Link to="/clothing">Clothing</Link> | </li>
          <li><Link to="/meals">Meals</Link> | </li>
          <li><Link to="/shelter">Shelter</Link> | </li>
          <li><Link to="/contact" title="Contact us">Contact</Link></li>
        </ul>
    </footer>
  );
}

export default Footer;